import { useRef, useState, useLayoutEffect } from 'react';
import { debounce } from '../../../utils/debounce.js';
import { BREADCRUMBS_CONSTANTS } from '../constants/index.js';
import { groupCrumbs, groupOrSkipCrumbs } from './groupCrumbs.js';

function useBreadcrumbsWrapper({ setIsDropdownVisible, children, breakpointWidth, }) {
    const wrapperRef = useRef(null);
    const [hiddenCrumbs, setHiddenCrumbs] = useState([]);
    const containerWidthRef = useRef(null);
    useLayoutEffect(() => {
        const container = wrapperRef.current;
        if (!container) {
            return;
        }
        // Breadcrumbs has changed so we need to recalculate
        containerWidthRef.current = null;
        groupCrumbs({ container, containerWidthRef, setHiddenCrumbs, breakpointWidth });
        const resizeCrumbs = () => {
            setIsDropdownVisible(false);
            groupOrSkipCrumbs({ container, containerWidthRef, setHiddenCrumbs, breakpointWidth });
        };
        const debouncedResizeCrumbs = debounce(resizeCrumbs, BREADCRUMBS_CONSTANTS.DEBOUNCE_DELAY);
        const debouncedResizeCrumbsImmediate = debounce(resizeCrumbs, BREADCRUMBS_CONSTANTS.HALF_OF_DEBOUNCE_DELAY);
        const onResize = (entries) => {
            const [{ target }] = entries;
            if (target === container) {
                debouncedResizeCrumbs();
            }
            // required for immediate resize
            debouncedResizeCrumbsImmediate();
        };
        const resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(container);
        return () => {
            resizeObserver.unobserve(container);
        };
    }, [setIsDropdownVisible, children, breakpointWidth]);
    return { wrapperRef, hiddenCrumbs };
}

export { useBreadcrumbsWrapper };
//# sourceMappingURL=useBreadcrumbsWrapper.js.map
